module.exports = __webpack_public_path__ + "img/chart-flowers-3-1x.55af3461.png";